import { render, staticRenderFns } from "./LogoMachination.vue?vue&type=template&id=2840a678&"
import script from "./LogoMachination.vue?vue&type=script&lang=ts&"
export * from "./LogoMachination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports